import React, { useState } from 'react';
import Dropdown from './Dropdown';
import './ValidatedDropdown.scss';

/**
 * Dropdown component with hidden input used for browser validation with required prop
 * @returns {Component}
 */
const ValidatedDropdown = ({
  id,
  required,
  className,
  onChange = () => {},
  preSelected,
  ...props
}) => {
  const [val, setVal] = useState(preSelected?.value || undefined);
  return (
    <div className={`validated-dropdown ${className}`}>
      <input
        aria-label={`input ${className}`}
        className=""
        name={id}
        required={required}
        onChange={() => {}}
        value={val || ''}
        tabIndex="-1"
      />
      <Dropdown
        className={className}
        preSelected={preSelected}
        onChange={(e) => {
          setVal(e.value);
          onChange(e);
        }}
        {...props}
      />
    </div>
  );
};

export default ValidatedDropdown;
